import(/* webpackMode: "eager" */ "/home/runner/work/multi-domain-website-framework/multi-domain-website-framework/apps/nippon-center-pakistan/src/app/en/reset-password/page.tsx");
